import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H3v16h16V11h-3zM5 19l3-4 2 3 3-4 4 5H5z"
}), 'AddPhotoAlternateSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AddPhotoAlternateSharp.js
// module id = 1902
// module chunks = 2